import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {environment} from "../../environments/environment";


@Injectable({ providedIn: 'root' })
export class ShippingService {

  backendUrl: string = environment.apiUrl;
  url_final: string

  constructor(private http: HttpClient) {
    
  }

  crearSsm(seller_shipping_method){
    this.url_final = this.backendUrl + "/seller_shipping_methods"
    this.url_final = `${this.url_final}`;
    return this.http.post<any>(this.url_final, { seller_shipping_method})
    .pipe(map(response => {
      // console.log("la respuesta crearssm es");
      // console.log(response)
      return response;
    }));
  }

  eliminarSsm(id){
    this.url_final = this.backendUrl + "/seller_shipping_methods/" + id
    this.url_final = `${this.url_final}`;
    return this.http.patch<any>(this.url_final, { 'visible': false})
    .pipe(map(response => {
      // console.log("la respuesta eliminarSsm es");
      // console.log(response)
      return response;
    }));
  }


}